import { render, staticRenderFns } from "./RequestRowOverflowMenu.vue?vue&type=template&id=a960605c"
import script from "./RequestRowOverflowMenu.vue?vue&type=script&lang=js"
export * from "./RequestRowOverflowMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports